import { action, observable, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { shipmentDocumentTypeEnum } from 'common/constants';

const documentTypeLabels = {
	[shipmentDocumentTypeEnum.packingSlip]: 'FULFILLMENTORDER.DOCUMENTTYPE.PACKINGSLIP',
	[shipmentDocumentTypeEnum.upcLabel]: 'FULFILLMENTORDER.DOCUMENTTYPE.UPCLABEL',
	[shipmentDocumentTypeEnum.gs1Label]: 'FULFILLMENTORDER.DOCUMENTTYPE.GS1LABEL',
};

/**
 * Prints one additional document at a time on purpose: without PrintNode each document opens its own browser
 * print dialog, so printing several in a row is clunky.
 */
class PrintAdditionalDocumentsViewStore extends BaseViewStore {
	@observable selectedType = null;

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.options = modalParams.data.availableTypes.map(type => ({ type, label: documentTypeLabels[type] }));
		this.selectedType = modalParams.data.availableTypes[0];
	}

	@action.bound
	selectType = type => {
		this.selectedType = type;
	};

	// Close first so the browser print dialog does not open behind the modal overlay.
	@action.bound
	print = () => {
		const type = this.selectedType;
		this.modalParams.close();
		this.modalParams.data.onPrint(type);
	};
}

export default PrintAdditionalDocumentsViewStore;
